/**
 * PEMILIK keranjang perangkat (`galea-preorder-cart`) — bughunt E9-8.
 *
 * Keranjang disimpan per perangkat, dan dulu tak tahu milik siapa. Ia hanya
 * dikosongkan oleh Keluar, sehingga setiap pergantian akun TANPA Keluar —
 * login di atas sesi lain, sesi kedaluwarsa lalu masuk akun lain, admin
 * "Login Ke Akun Pelanggan" berurutan — membawa barang, catatan, dan subtotal
 * harga level akun sebelumnya ke akun berikutnya.
 *
 * Aturannya (putusan "Lanjut" atas usulan E9, 2026-10-08):
 *  • Keranjang kosong tak punya pemilik.
 *  • Tamu (belum/tidak masuk) → keranjang dibiarkan.
 *  • Keranjang tanpa pemilik (diisi saat tamu, atau tersimpan sebelum aturan
 *    ini ada) diadopsi akun yang masuk — tamu yang login tak kehilangan isinya.
 *  • Pemilik ≠ akun yang masuk → keranjang dikosongkan.
 */
export type CartOwnerAction = "keep" | "adopt" | "clear";

export function cartOwnerAction(args: {
  owner: string | null;
  customerId: string | null;
  hasItems: boolean;
}): CartOwnerAction {
  if (!args.hasItems) return "keep";
  if (!args.customerId) return "keep";
  if (!args.owner) return "adopt";
  return args.owner === args.customerId ? "keep" : "clear";
}

/**
 * Pemilik dari JSON tersimpan. Bentuk baru `{ carts, owner }`; bentuk lama
 * (array / satu objek keranjang) tak punya pemilik → null.
 */
export function savedCartOwner(raw: unknown): string | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  const owner = (raw as Record<string, unknown>).owner;
  return typeof owner === "string" && owner.trim() ? owner : null;
}

/**
 * Bentuk simpan baru — `normalizeSavedCarts` sudah mengenali `{ carts }`.
 * Bundel (mig 8040) ikut di kunci `bundles` hanya bila ada, dan pilihan
 * hadiah pembelian (D3, kunci `gifts`) hanya bila ada — keranjang tanpa
 * keduanya tersimpan PERSIS seperti sebelumnya; pembaca lama mengabaikan
 * kunci baru.
 */
export function serializeOwnedCarts<T, B = never, G = never>(
  carts: readonly T[],
  owner: string | null,
  bundles: readonly B[] = [],
  gifts: G | null = null
): string {
  return JSON.stringify({
    carts,
    owner,
    ...(bundles.length ? { bundles } : {}),
    ...(gifts ? { gifts } : {})
  });
}
